import React from 'react';
import { Input, Select, Button } from './FormControls';
import { StepProps } from './types';

interface StepSocialProps extends StepProps {
  onNext: () => void;
  onBack: () => void;
}

const StepSocial: React.FC<StepSocialProps> = ({ formData, onChange, onNext, onBack }) => (
  <div className="space-y-6 animate-in fade-in slide-in-from-right-4 duration-500">
    <h3 className="text-2xl font-black text-gray-900">Social & Content Background</h3>
    <div className="grid grid-cols-1 gap-6">
      <Input
        label="TikTok Handle"
        placeholder="@username"
        value={formData.tiktokHandle}
        onChange={v => {
          const val = v.startsWith('@') || v === '' ? v : `@${v}`;
          onChange({ tiktokHandle: val });
        }}
        required
      />
      <Input
        label="Instagram Handle"
        placeholder="@username"
        value={formData.instagramHandle}
        onChange={v => {
          const val = v.startsWith('@') || v === '' ? v : `@${v}`;
          onChange({ instagramHandle: val });
        }}
        required
      />
      <Input label="YouTube Handle (Optional)" placeholder="Channel Link" value={formData.youtubeHandle || ''} onChange={v => onChange({ youtubeHandle: v })} />

      <Select
        label="How long have you been creating content?"
        value={formData.contentDuration}
        onChange={v => onChange({ contentDuration: v })}
        options={[
          "I'm brand new (less than 1 month)",
          "1-6 months",
          "6-12 months",
          "1-2 years",
          "2+ years"
        ]}
        required
      />

      <div className="space-y-3">
        <label className="block text-sm font-bold text-gray-700">Have you done paid brand deals or UGC work before?</label>
        <div className="flex gap-4">
          {['Yes', 'No'].map(opt => (
            <label key={opt} className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="brandDeals"
                checked={formData.brandDeals === opt}
                onChange={() => onChange({ brandDeals: opt as 'Yes' | 'No' })}
                className="w-4 h-4 text-purple-600 focus:ring-violet-400"
              />
              <span className="text-sm font-medium text-gray-700">{opt}</span>
            </label>
          ))}
        </div>
      </div>

      {formData.brandDeals === 'Yes' && (
        <Input
          label="Which brands?"
          value={formData.brandsIfYes || ''}
          onChange={v => onChange({ brandsIfYes: v })}
          placeholder="List a few..."
        />
      )}
    </div>
    <div className="flex justify-between pt-6">
      <Button variant="secondary" onClick={onBack}>← Back</Button>
      <Button onClick={onNext}>Next Step →</Button>
    </div>
  </div>
);

export default StepSocial;
